export default __webpack_public_path__ + "static/univers-bold-cond-8db894366cd08242cb04f6424778db09.woff";